import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const SEIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="SE" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#3D58DB"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#FECA00"
          fillRule="evenodd"
          d="M5 0h2v5h9v2H7v5H5V7H0V5h5V0Z"
          clipRule="evenodd"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
